(() => {
  const initialized = new WeakSet();
  const hover = matchMedia('(hover: hover) and (pointer: fine)');
  const init = () => document.querySelectorAll('.header__inline-menu details').forEach(details => {
    if (initialized.has(details)) return;
    initialized.add(details);
    const summary = details.querySelector(':scope > summary');
    if (!summary?.querySelector('.av-parent-menu-link')) return;
    let timer;
    const setOpen = open => { details.open = open; summary.setAttribute('aria-expanded', String(open)); };
    details.addEventListener('pointerenter', () => {
      if (!hover.matches) return;
      clearTimeout(timer);
      const scope = details.parentElement.closest('details') || details.closest('nav');
      scope.querySelectorAll('details[open]').forEach(other => {
        if (other !== details && !other.contains(details) && !details.contains(other)) {
          other.open = false;
          other.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
        }
      });
      setOpen(true);
    });
    details.addEventListener('pointerleave', () => {
      if (hover.matches) timer = setTimeout(() => { if (!details.contains(document.activeElement)) setOpen(false); }, 180);
    });
    summary.querySelector('.av-parent-menu-link').addEventListener('click', event => event.stopPropagation());
    details.addEventListener('toggle', () => summary.setAttribute('aria-expanded', String(details.open)));
    summary.addEventListener('keydown', event => {
      if (event.key === 'ArrowDown') { event.preventDefault(); setOpen(true); summary.nextElementSibling?.querySelector('a[href]')?.focus(); }
    });
    details.addEventListener('keydown', event => {
      if (event.key === 'Escape') { clearTimeout(timer); setOpen(false); summary.focus(); event.stopPropagation(); }
    });
  });
  init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('click', event => {
    if (!event.target.closest('.header__inline-menu')) document.querySelectorAll('.header__inline-menu details[open]').forEach(details => { details.open = false; });
  });
})();
